import {ReactNode} from 'react';
import {isFabricWebview} from '~/common/utils/webview';
import {RSVPModal} from './RSVPModal';
import {RSVPModalVariantAB} from './RSVPModalVariantAB/RSVPModalVariantAB';
import {Payload, RsvpStatuses} from './RSVPModalVariantAB/types';

export type RSVPModalProps = {
  status: RsvpStatuses;
  onClose: () => void;
  open: boolean;
  onSubmitRSVP: (payload: Payload, doNotClose?: boolean) => Promise<void>;
};

export const RSVPModalTestAB = ({
  status = RsvpStatuses.No,
  onClose,
  open,
  onSubmitRSVP,
}: RSVPModalProps): ReactNode => {
  const isWebview = isFabricWebview();

  if (!open) {
    return null;
  }

  if (isWebview) {
    return (
      <>
        {open && <div className="active-overlay-bg" />}
        <RSVPModal status={status} onClose={onClose} open={open} onSubmitRSVP={onSubmitRSVP} />
      </>
    );
  }

  return (
    <RSVPModalVariantAB status={status} onClose={onClose} open={open} onSubmitRSVP={onSubmitRSVP} />
  );
};
